/** Each login/logout has its own lifetime, including repeated logins to the same account. */
let generation = 0;
let accountId: string | null = null;
const resets = new Set<() => void>();
const reads = new Set<() => void>();

export class SupersededRequest extends Error {
  constructor() { super("Request belongs to an earlier session"); this.name = "SupersededRequest"; }
}

export function requestScope() { return { generation, accountId }; }
export function assertRequestScope(expected: number): void {
  if (expected !== generation) throw new SupersededRequest();
}
export function identifyRequestScope(id: string): void { accountId = id; }
/** A replacement snapshot invalidates prior asynchronous work without clearing the visible account. */
export function advanceRequestScope(): void { generation++; for (const reset of reads) reset(); }
export function resetRequestScope(): void {
  advanceRequestScope(); accountId = null;
  for (const reset of resets) reset();
}
export function onRequestReadReset(reset: () => void): () => void { reads.add(reset); return () => reads.delete(reset); }
export function onRequestScopeReset(reset: () => void): () => void {
  resets.add(reset); return () => resets.delete(reset);
}
